const files = require.context('./', true, /index.js$/)

const PROPS_REG = /Props$/
const HADLE_REG = /SchemaHandle$/

let props = {}
let schemaHandle = {}

files.keys().forEach(key => {
  processKey(files(key))
})

function processKey (file) {
  for (let key in file) {
    if (PROPS_REG.test(key)) {
      props[key] = file[key]
    } else if (HADLE_REG.test(key)) {
      schemaHandle[key] = file[key]
    }
  }
}

export {
  props,
  schemaHandle
}
